import React, {useEffect, useState, useCallback} from 'react'
import PropTypes from 'prop-types'
import {Box, Fade, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import PopoverContent from './popover-content'
import {useLocation} from 'react-router-dom'

const ListMenuPopover = ({
    primarycategory,
    selectedMenuItem,
    setSelectedMenuItem,
    first_level_image_section,
    categoryData,
}) => {
    const isOpen = selectedMenuItem === primarycategory.uid
    const styles = useMultiStyleConfig('BraunMenu', {})
    const [drawerMenuTopMargin, setDrawerMenuTopMargin] = useState()
    const location = useLocation()

    const listMenuPopover = styles?.listMenuPopover || {}

    const secondLevelTitle =
        primarycategory?.second_level_categories?.[0]?.second_level_categories_title || ''

    const handleMouseLeave = () => {
        setSelectedMenuItem(null)
    }

    useEffect(() => {
        setSelectedMenuItem(null)
    }, [location])

    const updateHeaderHeight = useCallback(() => {
        if (typeof document === 'undefined') return

        const header = document.getElementById('main-header')
        const sovraHeader = document.getElementById('sovra-header')

        let sovraHeaderHeight = 0
        if (sovraHeader) {
            const rect = sovraHeader.getBoundingClientRect()
            if (rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight) {
                sovraHeaderHeight = rect.height
            }
        }

        const headerHeight = header ? header.offsetHeight : 0
        setDrawerMenuTopMargin(headerHeight + sovraHeaderHeight)
    }, [])

    useEffect(() => {
        if (!isOpen) return
        updateHeaderHeight()
    }, [isOpen, updateHeaderHeight])

    useEffect(() => {
        window.addEventListener('scroll', updateHeaderHeight)
        window.addEventListener('resize', updateHeaderHeight)

        return () => {
            window.removeEventListener('scroll', updateHeaderHeight)
            window.removeEventListener('resize', updateHeaderHeight)
        }
    }, [updateHeaderHeight])

    return (
        <>
            <Box {...listMenuPopover?.popoverOverlay} display={isOpen ? 'block' : 'none'} />
            <Box
                onMouseLeave={handleMouseLeave}
                className={isOpen ? 'visible-menu' : 'hidden-menu'}
                aria-hidden={isOpen ? 'false' : 'true'}
                style={{pointerEvents: isOpen ? 'auto' : 'none'}}
                sx={{
                    '.hidden-menu': {visibility: 'hidden'},
                    '.visible-menu': {visibility: 'visible'},
                }}
            >
                <Fade
                    in={isOpen}
                    style={{
                        position: 'fixed',
                        top: drawerMenuTopMargin,
                        left: 0,
                        width: '100vw',
                        zIndex: 50,
                        display: 'flex',
                        justifyContent: 'center',
                        pointerEvents: isOpen ? 'auto' : 'none',
                    }}
                    transition={{enter: {duration: 0.3}, exit: {duration: 0.5}}}
                >
                    <Box {...listMenuPopover.listMenuContent}>
                        <PopoverContent
                            second_level_categories={
                                primarycategory?.second_level_categories?.[0]
                                    ?.second_level_categories
                            }
                            first_level_image_section={first_level_image_section}
                            categoryData={categoryData}
                            secondLevelTitle={secondLevelTitle}
                        />
                    </Box>
                </Fade>
            </Box>
        </>
    )
}

ListMenuPopover.propTypes = {
    primarycategory: PropTypes.object,
    selectedMenuItem: PropTypes.string,
    setSelectedMenuItem: PropTypes.func,
    first_level_image_section: PropTypes.object,
    categoryData: PropTypes.object,
}

export default ListMenuPopover
